import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import BlankImg from "../../assets/images/blank.jpg";
import { ImageWithFallback } from "../../helper/helper";
import Pagination from "../../component/Pagination";
import $ from "jquery";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net-responsive-dt/css/responsive.dataTables.css";
import "datatables.net-buttons-dt/css/buttons.dataTables.css";
import "datatables.net";
import "datatables.net-responsive";
import "datatables.net-buttons";
import {
  Box,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Checkbox,
  Button,
  Modal,
  Link,
  CircularProgress,
} from "@mui/material";
import { defineLocale } from "moment/moment";
import { fetchLeaderboardData } from "../../action/leaderboardAction";
import VotesImg from "../../assets/images2/freeVotes.svg";
import DeleteIcon from "../../assets/images2/deleteIcon.svg";
import CheckBox from "../../component/CheckBox";
import { ToastContainer, toast } from "react-toastify";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import axios from "axios";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ViewGoal from "../../component/Modals/ViewGoal";
import LisitingSkeletonLeaderboard from "../common/LisitingSkeletonLeaderboard";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import Category from "../../component/admin/leaderboard/filters/Category";
import CCategory from "../../component/admin/CategoryFilterComponent/Index";
import { useSkipFirstRender } from "../../hooks/useSkipFirstRender";
import CategoryComponent from "../../component/users/CategoryComponent/Index";

const CustomTableCell = styled(TableCell)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  borderBottom: "none !important",
  position: "relative",
  "&::before": {
    // backgroundImage: `url(${addCircleIcon})`,
  },
}));

export default function Users() {
  const leadsData = useSelector((state) => state.leaderboard);
  const token = useSelector((state) => state.auth.token);
  const [myLeads, setLeads] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const dispatch = useDispatch();
  const tableRef = useRef(null);
  const [selectall, setSelectAll] = useState(false);
  const [offset, setOffset] = useState(0);
  const multipleSelect = useRef(new Map());
  const deleteSelected = useRef(null);
  const [openDelete, setOpenDelete] = useState(false);
  const [filter, setFilter] = useState("");
  const [subFilter, setSubFilter] = useState("");
  const [childFilter, setChildFilter] = useState("");
  const [openMulitDelete, setOpenMulitDelete] = useState(false);
  const [userView, setUserView] = useState(false);
  const goalCategories = useSelector((state) => state.goalCategories);
  useEffect(() => {
    dispatch(fetchLeaderboardData(token, filter));
  }, [dispatch, token]);

  useEffect(() => {
    if (leadsData?.data?.success) {
      if (leadsData?.data?.data?.rows?.length > 0) {
        setLeads(leadsData.data?.data.rows.slice(offset, offset + 10));
        // setCurrentPage(leadsData?.data?.data?.currentPage);
        setTotalPages(Math.ceil(leadsData?.data?.data?.count / 10));
      } else {
        setTotalPages(0);
        setLeads("NO Leads!");
      }
    } else if (!leadsData?.data?.success) {
      toast.error(leadsData?.data?.message);
      setLeads(leadsData?.data?.message);
    }
  }, [leadsData]);

  useSkipFirstRender(() => {
    setCurrentPage(1);
    setOffset(0);
    dispatch(fetchLeaderboardData(token, filter, subFilter, childFilter));
  }, [filter]);

  useSkipFirstRender(() => {
    setCurrentPage(1);
    setOffset(0);
    dispatch(fetchLeaderboardData(token, filter, subFilter, childFilter));
  }, [subFilter]);

  useSkipFirstRender(() => {
    setCurrentPage(1);
    setOffset(0);
    dispatch(fetchLeaderboardData(token, filter, subFilter, childFilter));
  }, [childFilter]);

  const handleChangePage = (event, newPage) => {
    // dispatch(fetchLeaderboardData(token, newPage));
    setCurrentPage(newPage);
    const offset = newPage * 10 - 10;
    setOffset(offset);
    if (leadsData?.data?.data?.rows?.length > 0) {
      setLeads(leadsData.data?.data.rows.slice(offset, offset + 10));
    }
  };

  const goalsColumn = [
    { id: "select", label: "", minWidth: 105 },
    { id: "videos", label: "VIDEO", minWidth: 105 },
    { id: "video_name", label: "NAME", minWidth: 105 },
    { id: "club_name", label: "CLUB NAME", minWidth: 500 },
    { id: "votes", label: "VOTES", minWidth: 500 },
    { id: "team_logo", label: "Team", minWidth: 105 },
    { id: "user_actions", label: "ACTIONS", minWidth: 210 },
  ];

  async function handleDelete() {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/deleteGoal/${deleteSelected.current.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.success) {
        dispatch(fetchLeaderboardData(token, filter));
        toast.success("video deleted successfully");
      }
    } catch (error) {
      toast.error("Please try again..");
    } finally {
      setOpenDelete(false);
    }
  }

  async function handleMultipleDelete() {
    try {
      const ids = Array.from(multipleSelect.current.entries()).map(
        (ele) => ele[0]
      );
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/deleteMultipleGoals`,
        {
          ids,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.success) {
        dispatch(fetchLeaderboardData(token, filter));
        toast.success("Selected videos deleted successfully");
      }
    } catch (error) {
      toast.error("Please try again..");
    } finally {
      multipleSelect.current.clear();
      setOpenMulitDelete(false);
    }
  }

  return (
    <React.Fragment>
      <ToastContainer />
      <Box className="page_title tournament_title">
        <Typography variant="h1" component="h1">
          Leaderboards
        </Typography>
        <Button
          className="delete-search-btn"
          onClick={() => {
            if (multipleSelect.current && multipleSelect.current.size > 0) {
              setOpenMulitDelete(true);
            }
          }}
        >
          <DeleteOutlineIcon className="delete-icon" />
        </Button>
      </Box>
      <Box className="page_inner">
        {/* <CCategory
          filter={filter}
          setFilter={setFilter}
          subFilter={subFilter}
          setSubFilter={setSubFilter}
        /> */}
        {goalCategories.loading ? (
          <CircularProgress />
        ) : Array.isArray(goalCategories.data?.data) ? (
          <CategoryComponent
            categories={goalCategories.data?.data}
            filter={filter}
            setFilter={setFilter}
            subFilter={subFilter}
            setSubFilter={setSubFilter}
            childFilter={childFilter}
            setChildFilter={setChildFilter}
            page={"leaderboard-admin"}
          />
        ) : (
          "No category data found"
        )}
        <Box className="page_table">
          <TableContainer
            component={Paper}
            className="customer_form user_table"
          >
            <Table
              aria-label="leads table"
              style={{ width: "100%", minWidth: "900px" }}
            >
              <TableHead className="table_Head">
                <TableRow key="tb_head_leaderboard">
                  {goalsColumn.map((column) =>
                    column.id != "select" ? (
                      <TableCell key={column.id}>{column.label}</TableCell>
                    ) : (
                      <TableCell key={column.id}>
                        <Box className="checkbox-td">
                          <input
                            type="checkbox"
                            className="siteCheckBox"
                            checked={selectall}
                            onChange={(e) => {
                              if (!e.target.checked) {
                                multipleSelect.current.clear();
                              }
                              setSelectAll(e.target.checked);
                            }}
                          />
                        </Box>
                      </TableCell>
                    )
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.isArray(myLeads) && myLeads.length > 0 ? (
                  myLeads.map((value, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <Box className="checkbox-td">
                          <CheckBox
                            multipleSelect={multipleSelect}
                            selectall={selectall}
                            data={value}
                            key={value.id}
                          />
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className="property_name">
                          <Box className="p_image">
                            <ImageWithFallback
                              src={value.thumbnail}
                              alt={""}
                              fallbackSrc={BlankImg}
                            />
                            <Box className="playIcon-wrapper">
                              <Box
                                component={Link}
                                href={value?.video_link}
                                target="_blank"
                              >
                                <PlayArrowIcon className="playIcon" />
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className="td-wrapper td-title">
                          <Typography
                            variant="h4"
                            component="h4"
                            className="td-text"
                          >
                            {value?.goalUserDetails?.firstName +
                              " " +
                              value?.goalUserDetails?.lastName}
                          </Typography>
                        </Box>
                      </TableCell>

                      <TableCell>
                        <Box className="td-wrapper">
                          <Typography
                            variant="p"
                            component="p"
                            className="td-text"
                          >
                            {value?.club}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className="td-wrapper">
                          <img
                            src={VotesImg}
                            width={20}
                            height={20}
                            style={{ color: "yellow", marginRight: "10px" }}
                          />
                          <Typography
                            variant="p"
                            component="p"
                            className="td-text"
                          >
                            {value?.voteCount}
                          </Typography>
                        </Box>
                      </TableCell>

                      <TableCell>
                        <Box className="td-wrapper">
                          <img
                            src={
                              value.club_img
                                ? value.club_img
                                : value?.tournamentDetails?.img
                                ? value.tournamentDetails.img
                                : BlankImg
                            }
                            width={48}
                            height={48}
                            style={{ borderRadius: "50%" }}
                          />
                        </Box>
                      </TableCell>

                      <TableCell>
                        <Box className="table-actions">
                          <Box className="action-wrapper">
                            <Button
                              variant="text"
                              onClick={() => {
                                deleteSelected.current = value;
                                setOpenDelete(true);
                              }}
                            >
                              <img src={DeleteIcon} alt="" />
                            </Button>
                            <Button
                              variant="outlined"
                              className="visible_user"
                              onClick={() => {
                                deleteSelected.current = value;
                                setUserView(true);
                              }}
                            >
                              <VisibilityIcon className="visible_icon" />
                            </Button>
                          </Box>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                ) : myLeads !== "NO Leads!" ? (
                  Array.from({ length: 10 }).map((e, i) => (
                    <LisitingSkeletonLeaderboard />
                  ))
                ) : (
                  <TableRow component={`tr`}>
                    <TableCell colSpan={5} style={{ textAlign: "center" }}>
                      {/* {myLeads} */}
                      No Goals Found!!
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {totalPages > 1 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              handleChangePage={handleChangePage}
            />
          )}
        </Box>
      </Box>
      {/* delete goal video modal  */}
      <Modal
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="deleteModal">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are You sure . You want to delete this Video.
          </Typography>
          <Box className="buttons-div">
            <Button variant="outlined" onClick={() => setOpenDelete(false)}>
              cancel
            </Button>
            <Button variant="outlined" onClick={handleDelete}>
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* delete multiple video delete modal  */}
      <Modal
        open={openMulitDelete}
        onClose={() => setOpenMulitDelete(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="deleteModal">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are You sure . You want to delete the selected videos.
          </Typography>
          <Box className="buttons-div">
            <Button
              variant="outlined"
              onClick={() => setOpenMulitDelete(false)}
            >
              cancel
            </Button>
            <Button variant="outlined" onClick={handleMultipleDelete}>
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>

      <ViewGoal
        setUserView={setUserView}
        userView={userView}
        deleteSelected={deleteSelected}
      />
    </React.Fragment>
  );
}
